__turbopack_context__.v({
  "hamburger": "hamburgeroverlaymenu-module-scss-module__QkrUMG__hamburger",
  "hamburgerBlue": "hamburgeroverlaymenu-module-scss-module__QkrUMG__hamburgerBlue",
  "hamburgerMenuContainer": "hamburgeroverlaymenu-module-scss-module__QkrUMG__hamburgerMenuContainer",
  "itemLangShort": "hamburgeroverlaymenu-module-scss-module__QkrUMG__itemLangShort",
  "menuBottom": "hamburgeroverlaymenu-module-scss-module__QkrUMG__menuBottom",
  "menuClose": "hamburgeroverlaymenu-module-scss-module__QkrUMG__menuClose",
  "menuContainer": "hamburgeroverlaymenu-module-scss-module__QkrUMG__menuContainer",
  "menuItem": "hamburgeroverlaymenu-module-scss-module__QkrUMG__menuItem",
  "overlayMenu": "hamburgeroverlaymenu-module-scss-module__QkrUMG__overlayMenu",
  "overlayMenuShow": "hamburgeroverlaymenu-module-scss-module__QkrUMG__overlayMenuShow",
  "ulMainNav": "hamburgeroverlaymenu-module-scss-module__QkrUMG__ulMainNav",
  "vertalingContainer": "hamburgeroverlaymenu-module-scss-module__QkrUMG__vertalingContainer",
});
